// extracted by mini-css-extract-plugin
export var boxItems = "_bg-1";
export var boxItemsLg = "_bg-2";
export var button = "_bg-7";
export var buttonLg = "_bg-8";
export var filterGroupBox = "_bg-0";
export var icon = "_bg-3";
export var iconSecondary = "_bg-6";
export var iconWrapper = "_bg-4";
export var iconWrapperLg = "_bg-5";